// src/components/portal/SupervisorLogin.js
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { getFunctions } from "firebase/functions";
import { httpsCallable } from "../../shared/legacyData/legacyCallable";
import tpcLogo from "../../images/TPC-logo-light.png";
import "./Portalauth.css";

const CONFIG = {
company: "TPC_Group",
collectionBrand: "TechPerformanceCentre",
registerRoute: "/supervisor-register",
dashboardRoute: "/supervisor-dashboard",
roleSelectRoute: "/portal-role-select",
};

export default function SupervisorLogin() {
const [email, setEmail]         = useState("");
const [busy, setBusy]           = useState(false);
const [err, setErr]             = useState("");

const nav = useNavigate();
const fn  = getFunctions();
const getSystemDocs = httpsCallable(fn, "getSystemDocuments");

const normalizeEmail = (value) => String(value || "").trim().toLowerCase();
const supervisorEmail = (doc) => normalizeEmail(doc?.email || doc?.supervisorEmail || doc?.contactEmail);
const pickSupervisorDoc = (docs, email) => {
const safeEmail = normalizeEmail(email);
const rows = Array.isArray(docs) ? docs : [];
return rows.find((doc) => supervisorEmail(doc) === safeEmail) || null;
};

const handleLogin = async (e) => {
e.preventDefault();
setErr("");
if (!email) return setErr("Please enter your email address.");
setBusy(true);

try {
    // 1. Look up supervisor record by email
    const safeEmail = normalizeEmail(email);
    let supervisorDoc = null;
    try {
    const res = await getSystemDocs({
        company: CONFIG.company,
        collectionBrand: CONFIG.collectionBrand,
        systemName: "supervisors",
        filters: [{ field: "email", operator: "==", value: safeEmail }],
        auth: true,
    });
    const payload = res?.data?.data ?? res?.data?.documents ?? res?.data;
    const docs = Array.isArray(payload) ? payload : Object.values(payload || {});
    supervisorDoc = pickSupervisorDoc(docs, safeEmail);
    } catch (_) { /* ignore */ }

    if (!supervisorDoc) {
    // Fallback: fetch all and match
    try {
        const res2 = await getSystemDocs({
        company: CONFIG.company,
        collectionBrand: CONFIG.collectionBrand,
        systemName: "supervisors",
        auth: true,
        });
        const payload = res2?.data?.data ?? res2?.data?.documents ?? res2?.data;
        const all = Array.isArray(payload) ? payload : Object.values(payload || {});
        supervisorDoc = pickSupervisorDoc(all, safeEmail);
    } catch (_) { /* ignore */ }
    }

    if (!supervisorDoc) {
    setBusy(false);
    return setErr("No supervisor account found for this email. Please register or contact TPC administration.");
    }

    // 3. Check if also a learner — edge case
    let isAlsoLearner = false;
    try {
    const applicantRes = await getSystemDocs({
        company: CONFIG.company,
        collectionBrand: CONFIG.collectionBrand,
        systemName: "Applicants",
        filters: [{ field: "email", operator: "==", value: safeEmail }],
        auth: true,
    });
    const applicants = Array.isArray(applicantRes.data)
        ? applicantRes.data
        : (applicantRes.data?.documents || []);
    isAlsoLearner = applicants.length > 0 && applicants[0]?.isCompleted;
    } catch (_) { /* ignore */ }

    // 4. Store session
    sessionStorage.setItem("portalRole", "supervisor");
    sessionStorage.setItem("portalEmail", safeEmail);
    sessionStorage.setItem("portalSupervisorId", supervisorDoc.id || supervisorDoc.uniqueId || "");
    sessionStorage.setItem("portalSupervisorDoc", JSON.stringify(supervisorDoc));
    sessionStorage.setItem("portalIsAlsoLearner", isAlsoLearner ? "true" : "false");
    sessionStorage.setItem("portalUser", JSON.stringify({
    role: "supervisor",
    email: safeEmail,
    name: `${supervisorDoc.name || ""} ${supervisorDoc.surname || ""}`.trim(),
    id: supervisorDoc.id || supervisorDoc.uniqueId || "",
    authUid: supervisorDoc.authUid || "",
    }));

    // 5. Route
    if (isAlsoLearner) {
    nav(CONFIG.roleSelectRoute);
    } else {
    nav(CONFIG.dashboardRoute);
    }
} catch (ex) {
    setErr(ex.message || "Login failed. Please try again.");
} finally {
    setBusy(false);
}
};

return (
<div className="ar-container">
    {/* ── Left dark panel ── */}
    <div className="ar-left">
    <div className="ar-logo-box">
        <img src={tpcLogo} alt="TPC" className="ar-logo" />
    </div>
    <div className="ar-banner-text">Welcome Back, Supervisor</div>
    </div>

    {/* ── Right white panel ── */}
    <div className="ar-right">
    <form className="ar-form" onSubmit={handleLogin}>
        <h2 className="ar-title">Supervisor Dashboard Login</h2>

        {err && <p className="ar-err">{err}</p>}

        <input
        type="email"
        placeholder="Email"
        className="ar-input"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
        />

        <button type="submit" className="ar-button" disabled={busy}>
        {busy ? (
            <div className="ar-button-loader">
            <div className="ar-spinner" />
            <span>Signing in…</span>
            </div>
        ) : "LOGIN"}
        </button>

        <p className="ar-small">
        Not registered?&nbsp;
        <Link to={CONFIG.registerRoute} style={{ fontWeight:"700" }}>Register here</Link>
        </p>

        <p className="ar-small" style={{ marginTop:"8px" }}>
        <Link to="/" style={{ color:"#9ca3af" }}>← Back to andus.co.za</Link>
        </p>
    </form>
    </div>
</div>
);
}

